import Vue from 'vue'
import Router from 'vue-router'
import Admin from './views/Admin'
import Feed from './views/Feed'
import Home from './views/Home'
import Login from './views/Login'
import Valeu from './views/Valeu'
import Emails from './views/Emails'
import base from './plugins/firebase'

Vue.use(Router)

const router = new Router({
    mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter: (to, from, next) => {
        base.auth().onAuthStateChanged(function(user) {
            if (user) {
                next()
            } else {
                next('/login')
            }
        });

      }
    },
    {
      path: '/admin/emails',
      name: 'emails',
      component: Emails,
      beforeEnter: (to, from, next) => {
          base.auth().onAuthStateChanged(function(user) {
              if (user) {
                  next()
              } else {
                  next('/login')
              }
          });

      }
    },
    {
        path: '/feed',
        name: 'feed',
        component: Feed 
    },
    {
        path: '/feed/:postKey',
        name: 'feedFrom',
        props: true,
        component: Feed 
    },
    {
        path: '/login',
        name: 'login',
        component: Login 
    },

  {
      path: '/obrigado',
      name: 'obrigado',
      component: Valeu
  },

  ]
})

export default router
 